import request from '@/utils/request'

// 关于协会、会员中心
export function getSingleArticle(params) {
	return request({
		url: '/jeecg-boot/index/singleArticle',
		method: 'GET',
		params: params
	})
}

// 协会荣誉，学习资料
export function getResourcese(params) {
	return request({
		url: '/jeecg-boot/index/resources',
		method: 'GET',
		params: params
	})
}
